import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { ScreeningTab } from '@pages/donor-detail/ui/ScreeningTab'

function ScreeningRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <ScreeningTab visitId={visitId} />
    </Suspense>
  )
}

export const Route = createFileRoute('/_protected/donors/$visitId/screening')({
  component: ScreeningRoute,
})
